var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M37.2,34.5c1.2-0.1,2.2-1.2,2.1-2.4V9.3c0.1-1.2-0.9-2.3-2.1-2.4H7.8C6.6,7,5.6,8.1,5.7,9.3v22.8 c-0.1,1.2,0.9,2.3,2.1,2.4h12.6v2.4h-4.2v1.2h12.6v-1.2h-4.2v-2.4H37.2z M23.6,36.9h-2.1v-2.4h2.1V36.9z M6.7,9.3 c-0.1-0.6,0.4-1.1,1-1.2c0,0,0.1,0,0.1,0h29.4c0.6,0,1.1,0.5,1.1,1.1c0,0,0,0.1,0,0.1v22.8c0,0.6-0.5,1.1-1.1,1.2H7.8 c-0.6-0.1-1.1-0.6-1.1-1.2V9.3z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 21.5,
  y: 34.5,
  fill: "#FFFFFF",
  width: 2.1,
  height: 2.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M7.8,33.3h29.4c0.6-0.1,1.1-0.6,1.1-1.2V9.3c0,0,0-0.1,0-0.1c0-0.6-0.5-1.1-1.1-1.1H7.8c0,0-0.1,0-0.1,0 c-0.6,0.1-1.1,0.6-1,1.2v22.8C6.7,32.7,7.2,33.2,7.8,33.3z M22.5,32.1c-0.6,0-1-0.5-1-1.2c0-0.7,0.4-1.2,1-1.2c0.6,0,1,0.5,1,1.2 C23.5,31.6,23.1,32.1,22.5,32.1z M7.8,9.3h29.4v19.2H7.8V9.3z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.8,
  y: 10.5,
  fill: "#FFFFFF",
  width: 27.3,
  height: 16.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M37.2,28.5V9.3H7.8v19.2H37.2z M8.8,10.5h27.3v16.8H8.8V10.5z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#28B557",
  cx: 22.5,
  cy: 30.9,
  rx: 1,
  ry: 1.2
}));

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.f4ec23c5b2bbd666484c99c18521ff03.svg";
export { ForwardRef as ReactComponent };